import "./Footer.css";
import logo from "../../assets/logo/logo.png";

import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="footer">


      <div className="container footer-grid">


        {/* Logo & About */}

        <div className="footer-column">
<Link to="/">
  <img
    src={logo}
    alt="Yadnya Handloom"
    className="footer-logo"
  />
</Link>

          <p>
            Preserving India's timeless weaving traditions through
            handcrafted luxury sarees made by skilled artisans.
          </p>


          <div className="social-icons">


            <a
              href="https://www.facebook.com/share/1HYx8dV1D2/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>


            <a
              href="https://www.instagram.com/yadnyahandloom"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>


            <a
              href="https://youtube.com/@yadnyahandloom"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>


          </div>

        </div>




        {/* Quick Links */}

        <div className="footer-column">

          <h3>Quick Links</h3>


          <Link to="/">
            Home
          </Link>


          <Link to="/our-story">
            Our Story
          </Link>


          <Link to="/shop">
            Shop
          </Link>


          <Link to="/contact">
            Contact
          </Link>


        </div>





        {/* Collections */}

        <div className="footer-column">

          <h3>Collections</h3>


          <Link to="/shop/paithani">
            Paithani
          </Link>


          <Link to="/shop/irkal">
            Ilkal
          </Link>


          <Link to="/shop/maheshwari">
            Maheshwari
          </Link>


          <Link to="/shop/chanderi">
            Chanderi
          </Link>


        </div>





        {/* Contact */}

        <div className="footer-column">


          <h3>
            Contact Us
          </h3>


          <p>
            <FaMapMarkerAlt />
            Workshop: Chhatrapati Sambhajinagar 431001, Maharashtra, India
          </p>
           <p>
            <FaMapMarkerAlt />
            Office: Kudal Sindhudurg 416520, Maharashtra, India
          </p>


          <p>
            <FaPhoneAlt />
            +91 7720089312
          </p>


          <p>
            <FaEnvelope />
            sales@yadnyahandloom.com
          </p>


        </div>



      </div>




      <div className="footer-bottom">


        © {new Date().getFullYear()} Yadnya Handloom.
        All Rights Reserved.


      </div>



    </footer>
  );
};


export default Footer;